/** @format */

export const PATHS = {
  HOME: "/",
  WORKS: "/works",
  SERVICES: "/services",
  ABOUT_US: "/about",
};
